import React from "react";
import sanitize from "sanitize-html";
import Image from "next/future/image";
import PropTypes from "prop-types";
import TaxServicesStyles from "@components/NonProfitIndustryPage/TaxServicesStyles";
import { ReactSVG } from "react-svg";

const sanitizeSettings = {
  allowedTags: ["p", "ol", "ul", "li", "h2", "img", "strong"],
  allowedAttributes: {
    img: ["src", "alt", "style", "height", "width"],
  },
};

const TaxServices = ({ data, onCtaClicked, isMobile }) => {
  const { title, title2, list, image, description2 } = data;
  return (
    <TaxServicesStyles>
      <div className="image-wrapper">
        <Image
          src={image.url}
          width={isMobile ? 393 : 430}
          height={isMobile ? 262 : 540}
        />
      </div>
      <div className="text-container">
        <h2 className="title">{title}</h2>
        <div className="features">
          {list.map((feature) => (
            <div key={feature.tax_title} className="feature-item">
              <h3>
                <ReactSVG
                  src="/static/images/icons/check-circle-orange.svg"
                  className="check-icon"
                />
                {feature.tax_title}
              </h3>
              <p>
                {feature.description}
                {feature.info && (
                  <span className="tooltip-inline">
                    <div className="tooltip-i">i</div>
                    <span className="tooltip-text-inline">{feature.info}</span>
                  </span>
                )}
              </p>
            </div>
          ))}
        </div>
        <h2 className="title">{title2}</h2>
        <div
          className="description2"
          dangerouslySetInnerHTML={{
            __html: sanitize(description2, sanitizeSettings),
          }}
        />
        <div className="ctaContainer">
          <button className="btn btn-secondary" onClick={onCtaClicked}>
            Schedule My Free Call
          </button>
        </div>
      </div>
    </TaxServicesStyles>
  );
};

TaxServices.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TaxServices;
